import './App.css';
// eslint-disable-next-line
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom'

import NavBar from "./NavBar"
import Home from "./Pages/Home/Home"
import Properties from './Pages/Properties/PropertiesPage';
import Contact from './Pages/Contact/FullContactPage';
import About from './Pages/About/AboutPage';
import Footer from './Footer'


function App() {
  return (
    <div className="App">
      
    <NavBar/>
    
    <Routes>
      <Route exact path="/" element={<Home/>} />
      <Route exact path="/Properties" element={<Properties/>}/>
      <Route exact path="/Contact" element={<Contact/>}/>
      <Route exact path="/About" element={<About/>}/>
    </Routes>
    
    <Footer/>
      
    </div>
  );
}

export default App;